module.exports = __webpack_public_path__ + "static/media/ST2.574a4483.mp3";